import { defineStyle } from "@chakra-ui/react";

export const WelcomeClassifierStyles = (isLearnFlow = false) => {
  return {
    hideVinContainer: defineStyle({
      marginLeft: ["30px", "30px", "50px", "52px", "52px", "52px"],
    }),
    showVinContainer: defineStyle({
      marginLeft: 0,
    }),
    // welcomeClassifierContainer: defineStyle({
    //   display: "grid",
    //   gridTemplateColumns: "repeat(14,1fr)",
    //   gap: "24px",
    // }),
    subContainer: defineStyle({
      // gridColumn: { base: "1/15", md: "2/14", lg: "3/13" },
      marginY: "12px",
      marginTop: isLearnFlow
        ? ["44px", "44px", "44px", "44px", "52px", "52px"]
        : "12px",
    }),
    // topicSelectorMainContainer: defineStyle({
    //   display: "grid",
    //   gridTemplateColumns: "repeat(14,1fr)",
    //   gap: "24px",
    // }),
    // topicSelectorIndividualContainer: defineStyle({
    //   gridColumn: { base: "1/15", md: "2/14", lg: "3/13" },
    // }),
    doubtUserWelcomeContainer: defineStyle({
      marginLeft: { base: "-14px", md: "0px" },
      paddingY: "20px",
    }),
    doubtAssistantWelcomeContainer: defineStyle({
      marginBottom: "12px",
    }),
  };
};
